module.exports = __webpack_public_path__ + "static/img/infoblokk_kedv_final_felso_cmyk_ESZA.500b2bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/infoblokk_kedv_final_felso_cmyk_ESZA.jpg
// module id = U0EH
// module chunks = 0